<template>
  <div class="report" v-if="load">
    <report-menu v-model="date"></report-menu>
    <div class="main">
      <h2 class="main-title"></h2>


    </div>
  </div>
</template>
<script>
import ReportMenu from '../components/ReportMenu'
import  moment from "moment";
moment.defineLocale('uk', null)
export default {
  name: 'Reports',
  components: {
    ReportMenu,
  },
  watch: {
    date: function (){
      this.load = false
      this.getData()
    }
  },
  data() {
    return {
      searchText: 'Test',
      chartOptions: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
      },
      datacollection: null,
      load: false,
      typeReport: "table",
      balanceTurnover: null,
      transactionsByGood: [],
      totalTransactionsByGood: {},
      highlighted: {},
      date: [new Date(moment().format('YYYY, MM, 01') ), new Date() ],
    }
  },
  created() {
    this.getData()
  },
  mounted () {
    this.fillData()
  },
  methods: {
    fillData () {
      this.datacollection = {
        labels: ['Газ', 'A-95', 'A-92'],
        datasets: [{
          label: 'My First Dataset',
          data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt()],
          backgroundColor: [
        'rgb(255, 99, 132)',
        'rgb(54, 162, 235)',
        'rgb(255, 205, 86)'
      ],
          hoverOffset: 4}
        ]
      }
    },
    getRandomInt () {
      return Math.floor(Math.random() * (5 + 1)) + 5
    },
    getData: function (){
      this.axios.all([
        this.axios.get('/userservice/v1/User/balance-turnover', {params: {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00'}}),
        this.axios.get('/userservice/v1/User/transactions-by-good', {params: {begDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 00:00:00'}}),
        //this.axios.get('https://map.svitpro.com.ua/messages-api')
      ]).then(
          this.axios.spread((balanceTurnover, transactionsByGood) => {
            this.balanceTurnover = balanceTurnover.data
            this.transactionsByGood = transactionsByGood.data.data
            this.totalTransactionsByGood =  transactionsByGood.data.total
            //  this.info = info.data
          })
      )
          .catch(error => {
            console.log('error_get_data');
            console.log(error);
            this.errored = true;
          })
          .finally(() => (
              this.load = true)
          )
    },
  }
}
</script>
<style>

</style>